var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTodoDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.524597 3.44265H1.79964M1.79964 3.44265H12M1.79964 3.44265V12.623C1.79964 12.9708 1.93398 13.3044 2.17309 13.5503C2.41221 13.7963 2.73653 13.9345 3.07469 13.9345H9.44992C9.78808 13.9345 10.1124 13.7963 10.3515 13.5503C10.5906 13.3044 10.725 12.9708 10.725 12.623V3.44265H1.79964ZM3.71221 3.44265V2.13118C3.71221 1.78335 3.84655 1.44977 4.08566 1.20382C4.32478 0.957875 4.64909 0.819702 4.98726 0.819702H7.53735C7.87551 0.819702 8.19982 0.957875 8.43894 1.20382C8.67806 1.44977 8.81239 1.78335 8.81239 2.13118V3.44265",
    stroke: "#738FB8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTodoDelete);
export default __webpack_public_path__ + "static/media/DashboardTodoDelete.64f9b00c2bab961a30e1428e434bb2ad.svg";
export { ForwardRef as ReactComponent };